module.exports = __webpack_public_path__ + "img/Hybrid-D-6.8f0155bb.jpg";